<template>
  <div class="animated fadeIn text-center">
    <b-row>
      <b-col sm="8">
        IP 주소를 기반으로 국가 정보를 표시합니다
      </b-col>
      <b-col sm="3" class="text-left">
        <c-switch color="success" label variant="pill" size="sm" defaultChecked v-model="use_geoip" @change="change_use_geoip"/>
      </b-col>
      <b-col sm="1">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain_modal = true"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="4">
        방화벽 모드 적용 국가를 선택하세요
      </b-col>
      <b-col sm="6">
        <b-form-input :disabled="!use_geoip" style="display:inline-block" v-model="country" placeholder="Enter Country name"></b-form-input>
      </b-col>
      <b-col sm="2" class="text-left">
        <b-form-checkbox :disabled="!use_geoip" v-model="select_all" @change="toggle_all">
          전체 선택
        </b-form-checkbox>
        <b-form-checkbox :disabled="!use_geoip" v-model="show_block_only" @change="save_show_status">
          선택만 표시
        </b-form-checkbox>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="4">
        선택된 국가 수
      </b-col>
      <b-col sm="8">
        {{country_code.length}}
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="12">
        <div class="pr-2 pl-2" v-show="(is_show(x) && !show_block_only) || (show_block_only && x.is_block)" v-for="(x, index) in country_info" style="min-width:75px; height:75px; display:inline-block;">
          <b-form-checkbox :disabled="!use_geoip" style="cursor:pointer;" v-model="x.is_block" class="is_check" @change="onSelect(x.Code, x.Name)">
            <CountryFlag class="explain" style="cursor:pointer;"  :country="x.Code" size='normal'/>
            <p :style="x.is_block ? 'font-weight:900' : ''">{{ country ? x.Name : x.Code}}</p>
          </b-form-checkbox>
        </div>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="국가 기반 차단"  class="modal-info" v-model="explain_modal" ok-variant="success" header-bg-variant="success" ok-only>
      <p>국가 코드 차단은 아이피를 국가로 변환 기능(GEO-IP)을 사용해야 합니다</p>
      <p>123.123.123.123 	&rArr; KR  </p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
